<template>
  <div>
    <v-navigation-drawer v-model="drawer" app color="grey lighten-4" floating>
      <div style="background-color: #76777a" :style="'height:' + appbarHeight + 'px'" class="d-flex justify-center align-center">
        <opq-logo :height="appbarHeight * 0.667" />
      </div>
      <template v-if="ressources.length > 0">
        <v-list nav>
          <v-list-item-group>
            <template v-for="(step, i) in steps">
              <v-divider :key="'divider-' + step.path" v-if="i != 0" class="mb-2"></v-divider>
              <v-list-item :disabled="(!sas && i != 0) || loading" :key="step.path" link :to="{ path: prepend + step.path, query: $route.query }">
                <v-list-item-title class="aleo opq-nav-title">
                  <template v-if="!notNumbered">{{ i + 1 }}. </template><ressource :code="step.code"></ressource>
                </v-list-item-title>
                <v-list-item-icon v-if="step.state">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" :color="step.state">{{ icons[step.state] }}</v-icon>
                    </template>
                    <span>{{ tooltips[step.state] }}</span>
                  </v-tooltip>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </template>
      <template v-else>
        <div class="pa-6">
          <v-skeleton-loader
            v-for="i in steps.length"
            :key="i"
            type="text"
            :width="Math.floor(Math.random() * 100) + 100"
            height="45"
          ></v-skeleton-loader>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar color="#76777a" app class="white--text" :height="appbarHeight">
      <v-app-bar-nav-icon @click="drawer = !drawer" color="white"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <template v-if="ressources.length > 0">
          <ressource code="titre-formulaire"></ressource>
        </template>
        <template v-else>
          <v-skeleton-loader type="text" width="250" height="15"></v-skeleton-loader>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="#3a3838" class="font-weight-bold white--text aleo d-none d-sm-flex" link :href="urlPortail">
        <v-icon class="mr-3">mdi-arrow-left</v-icon> Retour au portail
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-sheet class="ml-6 py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12">
        <template v-if="loading">
          <opq-loading />
        </template>
        <template v-else>
          <slot name="default"></slot>
        </template>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>
import AppbarBase from "@/mixins/AppbarBase"
import { mapGetters } from "vuex"
export default {
  mixins: [AppbarBase],
  data() {
    return {
      drawer: true,
      snackbar: false,
      icons: {
        success: "mdi-checkbox-marked-circle-outline",
        warning: "mdi-alert-circle-outline",
        error: "mdi-close-circle-outline"
      },
      tooltips: {
        success: "Étape complétée",
        warning: "Manque d'informations",
        error: "Erreur"
      }
    }
  },

  computed: {
    ...mapGetters(["sas", "ressources"])
  },

  props: {
    prepend: {
      type: String
    },
    steps: {
      type: Array
    },
    notNumbered: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    copyUrl() {
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.url = window.location.href
        this.snackbar = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.v-list-item {
  .v-list-item__title.opq-nav-title {
    white-space: pre-wrap;
  }
  &.v-list-item--active {
    .v-list-item__title.opq-nav-title {
      font-weight: 600;
    }
  }
}
</style>
